let globalCounter: number = 0;

export class EventSource<T> {
  public register(listener: (payload: T) => void): EventSourceBinding {
    const eventListener: number = globalCounter++;
    this.listeners.push([eventListener, listener]);
    return new EventSourceBinding(() => {
      for (let i = 0; i < this.listeners.length; ++i) {
        if (this.listeners[i][0] === eventListener) {
          this.listeners.splice(i, 1);
          return;
        }
      }
      throw new Error(`EventSource.unregister: eventListener does not exist: ${eventListener}`);
    });
  }

  public broadcast(payload: T): void {
    for (const l of this.listeners) {
      l[1](payload);
    }
  }

  private listeners: [number, (payload: T) => void][] = [];
}

export class EventSourceBinding {
  constructor(private unregisterFn: () => void) {}

  public unregister() {
    this.unregisterFn();
  }
}
